import { BrowserAnalytics } from '@remento/web-analytics-client/analytics.browser';

import { Router } from '../../router.js';

import { PageExitActivityEvent, PageInitActivityEvent } from './@types.js';

export function registerActivityHandler(router: Router, analytics: BrowserAnalytics) {
  const logger = router.logger.extend('activity-handler');
  router.registerHandler('activity-handler', (event, payload) => {
    switch (event) {
      case PageExitActivityEvent: {
        logger.debug('ACTIVITY_EVENT', () => ({ type: event, payload }));
        analytics.track('page.exit', { ...payload.data, ...payload.properties });
        return true;
      }
      case PageInitActivityEvent: {
        logger.debug('ACTIVITY_EVENT', () => ({ type: event, payload }));
        analytics.page(typeof payload.properties.pageId === 'string' ? payload.properties.pageId : 'unknown', {
          ...payload.data,
          ...payload.properties,
        });
        return true;
      }
    }
    return false;
  });
}
